import React, { Component } from 'react';
import screenshots from './assets/app-screenshots.png';
import logo from './assets/app-logo.png';
import alexaSkill from './assets/alexa-skill-logo.png';
import appleStore from './assets/apple-store.svg';
import android from './assets/android-store.svg';
import './App.css';

class BusDue extends Component {
  render() {
    return (
      <div className="App">
        <img id="app-logo" className="img-fluid" src={logo} alt="busdue app logo" />
        <img id="app-screenshots" src={screenshots} alt="busdue app screenshots" />
        <h1 id="tagLine">Mobile app for live London bus arrival times</h1>
        <p>Available for free on Android, iOS app stores and as an Amazon Alexa Skill</p>
        <div className="appStoreIconWrapper">
          <a href="https://play.google.com/store/apps/details?id=com.busdue">
            <img className="app-store-icon" src={android} alt="download Android version" />
          </a>
          <a href="https://www.amazon.co.uk/dp/B081H6447H/ref=sr_1_1?keywords=busdue&qid=1573733741&s=digital-skills">
            <img className="app-store-icon" src={alexaSkill} alt="download amazon alexa skill version" />
          </a>
          <a href="https://itunes.apple.com/gb/app/busdue/id1185327843?mt=8">
            <img className="app-store-icon" src={appleStore} alt="download iOS version" />
          </a>
        </div>
        <div>
          <a className="support" href="mailto:busduelondon@gmail.com">SUPPORT</a>
        </div>
      </div>
    );
  }
}

export default BusDue;



// WEBPACK FOOTER //
// ./src/BusDue.js